import { styled, Typography } from '@ori-ui/mui';
import type { FC } from 'react';

interface DialogHeaderProps {
  points: number | null;
}

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '120px',
  backgroundColor: theme.palette.purple[100],
  fontSize: '3rem',
  marginTop: theme.spacing(1),
}));

const Points = styled(Typography)(({ theme }) => ({
  width: theme.typography.pxToRem(74),
  height: theme.typography.pxToRem(74),
  borderRadius: '50%',
  backgroundColor: theme.palette.offer.dark,
  color: theme.palette.offer.contrastText,
  lineHeight: theme.typography.pxToRem(74),
}));

export const DialogHeader: FC<DialogHeaderProps> = ({ points }) => (
  <Header>
    <Points
      variant="h4"
      align="center"
    >
      {points}
    </Points>
  </Header>
);

export default DialogHeader;
